/**
 * Preview either guest checkout widget from a URL: `?widget=classic`,
 * `?widget=styled`, or `?widget=off` to go back to the normal split.
 *
 * It writes the override cookie the intent route already honours
 * (utils/checkout-widget-ab.ts). A forced visit is recorded as forced and left
 * out of the dash numbers, so previewing never skews the test. Client-safe: no
 * server imports, which is why it is not in checkout-widget-ab.ts.
 */
import { CheckoutWidgetVariantSchema } from '../schemas/api/admin/checkout-widget-ab';

/** Must match CHECKOUT_WIDGET_OVERRIDE_COOKIE in utils/checkout-widget-ab.ts. */
export const WIDGET_PREVIEW_COOKIE = 'sw_checkout_widget';

/** A day: long enough to try a few checkouts, short enough to forget safely. */
const PREVIEW_MAX_AGE_SECONDS = 60 * 60 * 24;

/**
 * The `document.cookie` assignment for a `?widget=` value, or null when the
 * value is absent or not one we know -- a stray query string changes nothing.
 */
export function widgetPreviewCookie(queryValue: unknown): string | null {
  const value = Array.isArray(queryValue) ? queryValue[0] : queryValue;
  if (value === 'off') {
    return `${WIDGET_PREVIEW_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
  }
  const variant = CheckoutWidgetVariantSchema.safeParse(value);
  if (!variant.success) return null;
  return `${WIDGET_PREVIEW_COOKIE}=${variant.data}; path=/; max-age=${PREVIEW_MAX_AGE_SECONDS}; SameSite=Lax`;
}
